import { render, staticRenderFns } from "./SubclientEditableDetail.vue?vue&type=template&id=53df6226&scoped=true"
import script from "./SubclientEditableDetail.vue?vue&type=script&lang=ts"
export * from "./SubclientEditableDetail.vue?vue&type=script&lang=ts"
import style0 from "./SubclientEditableDetail.vue?vue&type=style&index=0&id=53df6226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df6226",
  null
  
)

export default component.exports